angular.module("ainapp")
    .controller("otherSalesVoucherTrashController", ["app.config", "$scope", "LoginService", "AuthenticationService", "$state", "$stateParams", "MainService", "localStorageService", "$window",
            function (config, $scope, LoginService, AuthenticationService, $state, $stateParams, MainService, localStorageService, $window) {


            $scope.PageName = "Other Sales Voucher Trash";
            $scope.TokenInfo = AuthenticationService.getTokenInfo();
            if ($scope.TokenInfo == null) {
                $state.go("login");
            } else {
                $scope.checkUserPageAccess($scope.PageName);
            }

            $scope.loadKendo = function () {
                $scope.KendoGridSource = new kendo.data.DataSource({
                    transport: {
                        read: function (o) {


                            if ($scope.selectedVoucher.NameVal == "Sales Enquiry 2") {
                                MainService.DeletedSalesEnquiry2s(o.data).then(function (response) {
                                    o.success(response.data);
                                }, function (err) {
                                    o.success(false);
                                    toastr.error($scope.NetworkErrorLan);
                                })
                            } else if ($scope.selectedVoucher.NameVal == "Sales Enquiry 3") {
                                MainService.DeletedSalesEnquiry3s(o.data).then(function (response) {
                                    o.success(response.data);
                                }, function (err) {
                                    o.success(false);
                                    toastr.error($scope.NetworkErrorLan);
                                })
                            } else if ($scope.selectedVoucher.NameVal == "Sales Enquiry 4") {
                                MainService.DeletedSalesEnquiry4s(o.data).then(function (response) {
                                    o.success(response.data);
                                }, function (err) {
                                    o.success(false);
                                    toastr.error($scope.NetworkErrorLan);
                                })
                            } else if ($scope.selectedVoucher.NameVal == "Sales Quotation 2") {
                                MainService.DeletedSalesQuotation2s(o.data).then(function (response) {
                                    o.success(response.data);
                                }, function (err) {
                                    o.success(false);
                                    toastr.error($scope.NetworkErrorLan);
                                })
                            } else if ($scope.selectedVoucher.NameVal == "Sales Quotation 3") {
                                MainService.DeletedSalesQuotation3s(o.data).then(function (response) {
                                    o.success(response.data);
                                }, function (err) {
                                    o.success(false);
                                    toastr.error($scope.NetworkErrorLan);
                                })
                            } else if ($scope.selectedVoucher.NameVal == "Sales Quotation 4") {
                                MainService.DeletedSalesQuotation4s(o.data).then(function (response) {
                                    o.success(response.data);
                                }, function (err) {
                                    o.success(false);
                                    toastr.error($scope.NetworkErrorLan);
                                })
                            } else if ($scope.selectedVoucher.NameVal == "Sales Order 2") {
                                MainService.DeletedSalesOrder2s(o.data).then(function (response) {
                                    o.success(response.data);
                                }, function (err) {
                                    o.success(false);
                                    toastr.error($scope.NetworkErrorLan);
                                })
                            } else if ($scope.selectedVoucher.NameVal == "Sales Order 3") {
                                MainService.DeletedSalesOrder3s(o.data).then(function (response) {
                                    o.success(response.data);
                                }, function (err) {
                                    o.success(false);
                                    toastr.error($scope.NetworkErrorLan);
                                })
                            } else if ($scope.selectedVoucher.NameVal == "Sales Order 4") {
                                MainService.DeletedSalesOrder4s(o.data).then(function (response) {
                                    o.success(response.data);
                                }, function (err) {
                                    o.success(false);
                                    toastr.error($scope.NetworkErrorLan);
                                })
                            } else if ($scope.selectedVoucher.NameVal == "Delivery Note 2") {
                                MainService.DeletedDeliveryNote2s(o.data).then(function (response) {
                                    o.success(response.data);
                                }, function (err) {
                                    o.success(false);
                                    toastr.error($scope.NetworkErrorLan);
                                })
                            } else if ($scope.selectedVoucher.NameVal == "Delivery Note 3") {
                                MainService.DeletedDeliveryNote3s(o.data).then(function (response) {
                                    o.success(response.data);
                                }, function (err) {
                                    o.success(false);
                                    toastr.error($scope.NetworkErrorLan);
                                })
                            } else if ($scope.selectedVoucher.NameVal == "Delivery Note 4") {
                                MainService.DeletedDeliveryNote4s(o.data).then(function (response) {
                                    o.success(response.data);
                                }, function (err) {
                                    o.success(false);
                                    toastr.error($scope.NetworkErrorLan);
                                })
                            } else if ($scope.selectedVoucher.NameVal == "Sales Invoice 2") {
                                MainService.DeletedSalesInvoice2s(o.data).then(function (response) {
                                    o.success(response.data);
                                }, function (err) {
                                    o.success(false);
                                    toastr.error($scope.NetworkErrorLan);
                                })
                            } else if ($scope.selectedVoucher.NameVal == "Sales Invoice 3") {
                                MainService.DeletedSalesInvoice3s(o.data).then(function (response) {
                                    o.success(response.data);
                                }, function (err) {
                                    o.success(false);
                                    toastr.error($scope.NetworkErrorLan);
                                })
                            } else if ($scope.selectedVoucher.NameVal == "Sales Invoice 4") {
                                MainService.DeletedSalesInvoice4s(o.data).then(function (response) {
                                    o.success(response.data);
                                }, function (err) {
                                    o.success(false);
                                    toastr.error($scope.NetworkErrorLan);
                                })
                            } else {
                                o.success({
                                    Data: [],
                                    Total: 0
                                });
                            }


                        }
                    },
                    change: function (data) {},
                    schema: {
                        data: "Data",
                        total: "Total",
                        model: {
                            id: "Id",
                            fields: {
                                Date: {
                                    type: "date",
                                },
                                CreatedDate: {
                                    type: "date",
                                },
                                UpdatedDate: {
                                    type: "date",
                                },
                                VoucherNumber: {
                                    type: "string",
                                },
                                GrandTotal: {
                                    type: "number",
                                },
                                NetTotal: {
                                    type: "number",
                                },
                                TotalTax: {
                                    type: "number",
                                },
                                "Customer.Name": {
                                    type: "string",
                                },
                                "CreatedBy.UserName": {
                                    type: "string",
                                },
                                "UpdatedBy.UserName": {
                                    type: "string",
                                },
                            }
                        }
                    },
                    pageSize: 30,
                    serverPaging: true,
                    serverSorting: true,
                    serverFiltering: true,
                });

                $scope.KendoGridOptions = {
                    toolbar: ["excel"],
                    stretch: true,
                    selectable: true,
                    groupable: false,
                    height: 650,
                    sortable: true,
                    resizable: true,
                    dataSource: $scope.KendoGridSource,
                    pageable: true,
                    pageable: {
                        input: false,
                        refresh: true,
                        pageSizes: true,
                        info: true,
                    },
                    filterable: true,

                    columns: [
                        {
                            field: "VoucherNumber",
                            title: "#",
                            width: "100px"
                    },
                        {
                            field: "Date",
                            template: "<p> {{dataItem.Date | date: 'dd/MM/yyyy'}}<p/>",
                            title: "Date",
                            width: "100px"
                    },
                        {
                            field: "Customer.Name",
                            title: "Customer",
                            width: "200px"
                    },
                        {
                            field: "NetTotal",
                            title: "Net Total",
                            width: "100px"
                    }, {
                            field: "TotalTax",
                            title: "Total Tax",
                            width: "100px"
                    }, {
                            field: "GrandTotal",
                            title: "Grand Total",
                            width: "100px"
                    },
                        {
                            field: "CreatedBy.UserName",
                            title: "Created By",
                            width: "100px"
                    },
                        {
                            field: "CreatedDate",
                            template: "<p> {{dataItem.CreatedDate | date: 'dd/MM/yyyy'}}<p/>",
                            title: "Created Date",
                            width: "100px"
                    },
                        {
                            field: "UpdatedBy.UserName",
                            title: "Updated By",
                            width: "100px"
                    },
                        {
                            field: "UpdatedDate",
                            template: "<p> {{dataItem.UpdatedDate | date: 'dd/MM/yyyy'}}<p/>",
                            title: "Updated Date",
                            width: "100px"
                    },

                  ],
                };


            }


            $scope.Init = function () {

                $.LoadingOverlay("show", {
                    image: "images/load.gif",
                });

                $scope.VArray = [];

                MainService.GetCompanyProfile().then(function (response) {
                    $scope.CompanyProfile = response.data;

                    var temp14 = {
                        Id: 14,
                        Name: "Sales Enquiry 2",
                        NameVal: "Sales Enquiry 2"
                    };
                    if ($scope.CompanyProfile.SalesEnquiry2 != "" & $scope.CompanyProfile.SalesEnquiry2 != null) {
                        temp14.Name = $scope.CompanyProfile.SalesEnquiry2;
                    }
                    $scope.VArray.push(temp14);

                    var temp15 = {
                        Id: 15,
                        Name: "Sales Enquiry 3",
                        NameVal: "Sales Enquiry 3"
                    };
                    if ($scope.CompanyProfile.SalesEnquiry3 != "" & $scope.CompanyProfile.SalesEnquiry3 != null) {
                        temp15.Name = $scope.CompanyProfile.SalesEnquiry3;
                    }
                    $scope.VArray.push(temp15);

                    var temp16 = {
                        Id: 16,
                        Name: "Sales Enquiry 4",
                        NameVal: "Sales Enquiry 4"
                    };
                    if ($scope.CompanyProfile.SalesEnquiry4 != "" & $scope.CompanyProfile.SalesEnquiry4 != null) {
                        temp16.Name = $scope.CompanyProfile.SalesEnquiry4;
                    }
                    $scope.VArray.push(temp16);

                    var temp18 = {
                        Id: 18,
                        Name: "Sales Quotation 2",
                        NameVal: "Sales Quotation 2"
                    };
                    if ($scope.CompanyProfile.SalesQuotation2 != "" & $scope.CompanyProfile.SalesQuotation2 != null) {
                        temp18.Name = $scope.CompanyProfile.SalesQuotation2;
                    }
                    $scope.VArray.push(temp18);

                    var temp19 = {
                        Id: 19,
                        Name: "Sales Quotation 3",
                        NameVal: "Sales Quotation 3"
                    };
                    if ($scope.CompanyProfile.SalesQuotation3 != "" & $scope.CompanyProfile.SalesQuotation3 != null) {
                        temp19.Name = $scope.CompanyProfile.SalesQuotation3;
                    }
                    $scope.VArray.push(temp19);

                    var temp20 = {
                        Id: 20,
                        Name: "Sales Quotation 4",
                        NameVal: "Sales Quotation 4"
                    };
                    if ($scope.CompanyProfile.SalesQuotation4 != "" & $scope.CompanyProfile.SalesQuotation4 != null) {
                        temp20.Name = $scope.CompanyProfile.SalesQuotation4;
                    }
                    $scope.VArray.push(temp20);

                    var temp22 = {
                        Id: 22,
                        Name: "Sales Order 2",
                        NameVal: "Sales Order 2"
                    };
                    if ($scope.CompanyProfile.SalesOrder2 != "" & $scope.CompanyProfile.SalesOrder2 != null) {
                        temp22.Name = $scope.CompanyProfile.SalesOrder2;
                    }
                    $scope.VArray.push(temp22);

                    var temp23 = {
                        Id: 23,
                        Name: "Sales Order 3",
                        NameVal: "Sales Order 3"
                    };
                    if ($scope.CompanyProfile.SalesOrder3 != "" & $scope.CompanyProfile.SalesOrder3 != null) {
                        temp23.Name = $scope.CompanyProfile.SalesOrder3;
                    }
                    $scope.VArray.push(temp23);

                    var temp24 = {
                        Id: 24,
                        Name: "Sales Order 4",
                        NameVal: "Sales Order 4"
                    };
                    if ($scope.CompanyProfile.SalesOrder4 != "" & $scope.CompanyProfile.SalesOrder4 != null) {
                        temp24.Name = $scope.CompanyProfile.SalesOrder4;
                    }
                    $scope.VArray.push(temp24);

                    var temp26 = {
                        Id: 26,
                        Name: "Delivery Note 2",
                        NameVal: "Delivery Note 2"
                    };
                    if ($scope.CompanyProfile.DeliveryNote2 != "" & $scope.CompanyProfile.DeliveryNote2 != null) {
                        temp26.Name = $scope.CompanyProfile.DeliveryNote2;
                    }
                    $scope.VArray.push(temp26);

                    var temp27 = {

                        Id: 27,
                        Name: "Delivery Note 3",
                        NameVal: "Delivery Note 3"
                    };
                    if ($scope.CompanyProfile.DeliveryNote3 != "" & $scope.CompanyProfile.DeliveryNote3 != null) {
                        temp27.Name = $scope.CompanyProfile.DeliveryNote3;
                    }
                    $scope.VArray.push(temp27);

                    var temp28 = {
                        Id: 28,
                        Name: "Delivery Note 4",
                        NameVal: "Delivery Note 4"
                    };
                    if ($scope.CompanyProfile.DeliveryNote4 != "" & $scope.CompanyProfile.DeliveryNote4 != null) {
                        temp28.Name = $scope.CompanyProfile.DeliveryNote4;
                    }
                    $scope.VArray.push(temp28);

                    var temp31 = {
                        Id: 31,
                        Name: "Sales Invoice 2",
                        NameVal: "Sales Invoice 2"
                    };
                    if ($scope.CompanyProfile.SalesInvoice2 != "" & $scope.CompanyProfile.SalesInvoice2 != null) {
                        temp31.Name = $scope.CompanyProfile.SalesInvoice2;
                    }
                    $scope.VArray.push(temp31);

                    var temp32 = {
                        Id: 32,
                        Name: "Sales Invoice 3",
                        NameVal: "Sales Invoice 3"
                    };
                    if ($scope.CompanyProfile.SalesInvoice3 != "" & $scope.CompanyProfile.SalesInvoice3 != null) {
                        temp32.Name = $scope.CompanyProfile.SalesInvoice3;
                    }
                    $scope.VArray.push(temp32);

                    var temp33 = {
                        Id: 33,
                        Name: "Sales Invoice 4",
                        NameVal: "Sales Invoice 4"
                    };
                    if ($scope.CompanyProfile.SalesInvoice4 != "" & $scope.CompanyProfile.SalesInvoice4 != null) {
                        temp33.Name = $scope.CompanyProfile.SalesInvoice4;
                    }
                    $scope.VArray.push(temp33);

                    $scope.selectedVoucher = $scope.VArray[0];
                    $scope.loadKendo();
                    $.LoadingOverlay("hide");

                }, function (err) {
                    $.LoadingOverlay("hide");
                    toastr.error("Network Error");
                    $scope.load = false;
                })

            }
            $scope.Init();


            $scope.refresh = function () {
                $scope.selectedVoucher = $scope.VArray[0];
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }

            $scope.changeView = function (data) {
                $scope.selectedVoucher = data;
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }

            $scope.SearchKendo = function () {
                $("#Kendo-Grid").data("kendoGrid").dataSource.read();
            }


                }])
